<template>
  <!--   简化版手机号验证码登录 -->
  <div class="simple-login-phone-content">
    <div class="login-wrapper">
      <img
        :src="logoUrl"
        class="logo"
        alt="Logo"
      />
      <!-- <div class="login-title">验证码登录</div> -->
      <div class="desc">使用手机号快速登录，无账号将自动注册</div>
      
      <!-- 手机号输入框 -->
      <div class="phone-num-box">
      <div :class="['phone-box', 'top-box', phoneErr ? 'err-box': '']">
        <input 
          class="phone" 
          :value="phone" 
          @focus="focusFn" 
          @input="inputNumber" 
          maxlength="11"
          type="tel" 
          placeholder="请输入手机号" 
        />
        <div v-show="!!phone" class="clear" @click="clearPhone"></div>
      </div>
      <div class="err-tip">{{ phoneErr }}</div>
    </div>
    
    <!-- 验证码输入框 -->
    <div class="code-container">
      <div class="box">
        <div :class="codeErr ? 'login-code-box err-box' : 'login-code-box'">
          <input 
            class="code" 
            :value="code" 
            @input="inputCode" 
            type="text" 
            placeholder="请输入验证码" 
          />
          <div 
            :class="!!phone ? 'code-send not-disable' : 'code-send'" 
            @click="sendCaptcha" 
            v-if="sendCaptchaStatus"
          >
            获取验证码
          </div>
          <div class="code-send not-disable" v-else>{{ num }}s后重新发送</div>
        </div>
      </div>
      <div class="err-tip code-tip">{{ codeErr }}</div>
    </div>
    
    <!-- 协议勾选 -->
    <div class="agree-box">
      <img 
        :src="checkBox ? checkedIcon : uncheckedIcon"
        @click="changeCheckBox"
        class="img"
        alt="checkbox"
      />
      <div class="protocol-link">
        已阅读并同意
        <span @click="toProtocol('protocol')">《用户协议》</span>和<span @click="toProtocol('privacy')">《隐私条款》</span>
      </div>
    </div>
    
      <!-- 登录按钮 -->
      <div 
        :class="((!!phone && !!code) && !isLogining) ? 'button can-login' : 'button'"
        @click="login"
      >
        立即登录
      </div>
    </div>
    
    <!-- 协议确认弹窗（可选） -->
    <div v-if="showAgreeMask" class="agree-mask">
      <div class="agree-mask-content">
        <div class="agree-mask-title">温馨提示</div>
        <div class="agree-mask-desc">请先阅读并同意《用户协议》和《隐私条款》</div>
        <div class="agree-mask-btns">
          <div class="agree-mask-btn cancel" @click="noAgree">取消</div>
          <div class="agree-mask-btn confirm" @click="agree">同意</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { accountUrlHost, javaHost } from '@/bin/javaSetting';
import { MiguConfig } from '@/views/migu/utils/constant';
import './SimpleLoginPhone.less';

// 公共参数配置
const commonUrlData = {
  pkg: 'com.mobvoi.yuanchuangdao',
  platform: 'mini',
  region: 'i18s',
  origin: 'yuanchuangdao-mini'
};

const getCaptcha = (data) => {
  const requestData = {
    ...data,
    ...commonUrlData
  };
  
  // 构建查询字符串
  const params = new URLSearchParams();
  Object.keys(requestData).forEach(key => {
    params.append(key, requestData[key]);
  });

  return axios.get(`${accountUrlHost}/v3/captcha/sms?${params.toString()}`)
    .then(res => res.data);
};

const phoneLogin = (data) => {
  // 这里的 data 已经包含了必要的参数，但我们需要确保 URL 参数也带上公共参数
  const urlParams = new URLSearchParams();
  urlParams.append('pkg', commonUrlData.pkg);
  urlParams.append('platform', commonUrlData.platform);
  urlParams.append('region', commonUrlData.region);
  urlParams.append('hasPromottype', '1');

  // 登录接口的 body 参数
  const bodyData = {
    phone: data.phone,
    captcha_value: data.captcha_value,
    app: 'voice-maker-mini',
    origin: 'voice-maker-mini'
  };

  return axios.post(`${accountUrlHost}/v3/login/captcha?${urlParams.toString()}`, bodyData)
    .then(res => res.data);
};

const getUserInfo = (ww_token) => {
  const params = new URLSearchParams();
  params.append('ww_token', ww_token);
  params.append('channelCode', MiguConfig.schannel);

  // /apis 前缀在 ajaxConf 中被映射为 javaHost，这里直接拼接
  return axios.get(`${javaHost}/baohuo-account/v1/user?${params.toString()}`)
    .then(res => res.data);
};

const getToken = (ww_token) => {
  const params = new URLSearchParams();
  params.append('ww_token', ww_token);
  params.append('channelCode', MiguConfig.schannel);

  // /apis 前缀在 ajaxConf 中被映射为 javaHost，这里直接拼接
  return axios.get(`${javaHost}/baohuo-yuanchuang/migu/api/v1/getToken?${params.toString()}`)
    .then(res => res.data);
};

@Component({
  name: 'SimpleLoginPhone'
})
export default class SimpleLoginPhone extends Vue {
  @Prop({ type: String, default: '' }) openId;
  @Prop({ type: Boolean, default: false }) hasRegisted;

  // 数据属性
  phone = '';
  code = '';
  sendCaptchaStatus = true;
  phoneErr = '';
  codeErr = '';
  sucTip = '';
  num = 60;
  isLogining = false;
  checkBox = false;
  showAgreeMask = false;

  // 计算属性
  get logoUrl() {
    return 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/logo_202401051402.png';
  }

  get checkedIcon() {
    return 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/checkbox_checked_202401121548.png';
  }

  get uncheckedIcon() {
    return 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/checkbox_nochecked_202401121548.png';
  }

  // 方法
  checkPhone() {
    const reg = /^\d{11}$/;
    if (!reg.test(this.phone)) {
      this.phoneErr = '请输入正确格式的手机号';
      return false;
    }
    return true;
  }

  captchaCountdown() {
    this.num = 60;
    const timer = setInterval(() => {
      if (this.num === 0) {
        clearInterval(timer);
        this.sendCaptchaStatus = true;
      } else {
        this.num--;
      }
    }, 1000);
  }

  focusFn() {
    this.phoneErr = '';
  }

  inputCode(e) {
    const target = e.target;
    this.code = target.value;
    this.codeErr = '';
  }

  inputNumber(e) {
    const target = e.target;
    this.phone = target.value;
    this.sucTip = '';
    this.phoneErr = '';
    this.codeErr = '';
  }

  clearPhone() {
    this.phone = '';
    this.phoneErr = '';
  }

  async sendCaptcha() {
    if (!this.phone) {
      return;
    }

    if (!this.checkPhone()) {
      this.phoneErr = '请输入正确格式的手机号';
      return;
    }

    this.sendCaptchaStatus = false;
    this.sucTip = '';
    this.codeErr = '';

    const data = {
      usage: 'login',
      phone: this.phone,
      origin: 'voice-maker-mini'
    };

    try {
      const res = await getCaptcha(data);
      if (res.err_code === 0) {
        this.sendCaptchaStatus = false;
        this.sucTip = res.err_msg || '验证码已发送';
        this.captchaCountdown();
      } else {
        this.sendCaptchaStatus = true;
        this.sucTip = '';
        if (res.err_code === 2007 || (res.err_msg && (res.err_msg.indexOf('频繁') !== -1 || res.err_msg.indexOf('短信') !== -1))) {
          this.codeErr = res.err_msg || '';
        } else {
          if (res.err_code === 308) {
            this.codeErr = '验证码发送失败！请检查手机号是否正确！';
          } else {
            this.codeErr = res.err_msg || '服务出错，code94';
          }
        }
      }
    } catch (error) {
      this.sendCaptchaStatus = true;
      this.sucTip = '';
      this.codeErr = '短信发送失败，请重试';
    }
  }

  async codeLogin() {
    this.isLogining = true;
    const data = {
      phone: this.phone,
      captcha_value: this.code,
      app: 'voice-maker-mini',
      origin: 'voice-maker-mini'
    };

    try {
      const res = await phoneLogin(data);
      if (res.err_code === 0) {
        // 登录成功，存储用户信息
        // localStorage.setItem('wwid', res.result.wwid);
        // localStorage.setItem('phone', res.result.phone);
        localStorage.setItem('session_id', res.result.session_id);

        // 调用 getToken
        const userInfoRes = await getUserInfo(res.result.session_id);
        if (userInfoRes.code != 200) { 
          return;
        }
        try {
          const tokenRes = await getToken(res.result.session_id);
          if (tokenRes.code === 200 && tokenRes.data) {
            // localStorage.setItem('migu_token', tokenRes.data);
            // 触发登录成功事件
            const emitData = {
              ...res.result,
              migu_token: tokenRes.data.token
            };
            this.$emit('loginSuccess', emitData);
          }
        } catch (e) {
          console.error('Get token failed:', e);
        }

      } else if (res.code === 40401500) {
        this.codeErr = res.message || '登录异常';
      } else {
        if (res.err_msg && res.err_msg.indexOf('验证码') !== -1) {
          this.codeErr = '验证码不正确，请检查短信内容';
        } else {
          this.codeErr = '验证码不正确，请检查短信内容';
        }
      }
    } catch (error) {
      alert('登录失败请重试');
      console.error('Login error:', error);
    } finally {
      this.isLogining = false;
    }
  }

  login() {
    if (this.isLogining) {
      return;
    }
    if (!this.phone) {
      return;
    }
    if (!this.checkPhone()) {
      this.phoneErr = '请输入正确格式的手机号';
      return;
    }
    if (!this.checkBox) {
      this.showAgreeMask = true;
      return;
    }
    if (!this.code || !/\d{4}$/.test(this.code)) {
      this.codeErr = '请输入正确格式的验证码';
      return;
    }
    this.codeLogin();
  }

  changeCheckBox() {
    this.checkBox = !this.checkBox;
  }

  toProtocol(name) {
    const navtitle = '元创岛';
    // TODO: 替换为实际的协议地址
    const protocolUrlHost = 'https://your-domain.com/protocol';
    const url = `${protocolUrlHost}/${name}`;
    window.open(url, '_blank');
  }

  agree() {
    this.checkBox = true;
    this.showAgreeMask = false;
  }

  noAgree() {
    this.showAgreeMask = false;
  }

  close() {
    this.$emit('close-login');
  }
}
</script>

<style lang="less" scoped>
@import './SimpleLoginPhone.less';

// 协议确认弹窗样式
.agree-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  
  .agree-mask-content {
    width: 600px;
    background: #FFFFFF;
    border-radius: 24px;
    padding: 48px;
    
    .agree-mask-title {
      font-size: 36px;
      font-weight: 600;
      color: #333333;
      text-align: center;
      margin-bottom: 32px;
    }
    
    .agree-mask-desc {
      font-size: 28px;
      color: #666666;
      text-align: center;
      margin-bottom: 48px;
      line-height: 1.5;
    }
    
    .agree-mask-btns {
      display: flex;
      gap: 24px;
      
      .agree-mask-btn {
        flex: 1;
        height: 88px;
        line-height: 88px;
        text-align: center;
        border-radius: 16px;
        font-size: 32px;
        cursor: pointer;
        
        &.cancel {
          background: #F5F5F5;
          color: #666666;
        }
        
        &.confirm {
          background: #E7166B;
          color: #FFFFFF;
        }
      }
    }
  }
}
</style>
